import { InteractiveContainer } from "@jugl-web/ui-components";
import { FC, useEffect, useState } from "react";
import { EditableMediaContainer } from "../EditableMediaContainer";
import { ReactComponent as SmileIcon } from "./assets/smile.svg";

interface ChatBotImagePickerProps {
  image: string | File | null;
  onImageChange: () => void;
  onImageRemove: () => void;
}
export const ChatBotImagePicker: FC<ChatBotImagePickerProps> = ({
  image,
  onImageChange,
  onImageRemove,
}) => {
  const [imageSrc, setImageSrc] = useState<string | null>(null);

  useEffect(() => {
    if (image instanceof File) {
      const objectUrl = URL.createObjectURL(image);
      setImageSrc(objectUrl);

      return () => {
        URL.revokeObjectURL(objectUrl);
      };
    }

    setImageSrc(image);

    return undefined;
  }, [image]);

  const wrapperClassName =
    "border-grey-400 relative flex h-[60px] w-[60px] shrink-0 items-center justify-center overflow-hidden rounded-full border border-solid";

  if (imageSrc) {
    return (
      <EditableMediaContainer
        onSelectNew={onImageChange}
        onRemove={onImageRemove}
      >
        <div className={wrapperClassName}>
          <img src={imageSrc} className="h-full w-full object-cover" alt="" />
        </div>
      </EditableMediaContainer>
    );
  }

  return (
    <InteractiveContainer className={wrapperClassName} onClick={onImageChange}>
      <SmileIcon />
    </InteractiveContainer>
  );
};
